import React from 'react';
import moment from 'moment';
import FadingCircleLoader from '../components/FadingCircleLoader';
import RouterLink from '../components/RouterLink';
import { NotificationData } from './notifications-types';

export interface NotificationItemPropsOld {
  closeNotificationCenter: AnyFunc;
  notification?: NotificationData;
}

export const ResourceTypes = {
  Template: 0,
  Form: 1,
  DataSource: 2,
  Workflow: 3,
  WorkflowJob: 4,
  App: 5
};

export const NotificationStatus = {
  Queued: 0,
  InProgress: 1,
  Done: 2,
  Error: 3
};

function getResourceUrl(type, id) {
  switch (type) {
    case ResourceTypes.Form:
      return `/forms/${id}`;
    case ResourceTypes.Template:
      return `/templates/${id}`;
    case ResourceTypes.DataSource:
      return `/datasource/edit?id=${id}`;
    case ResourceTypes.Workflow:
      return `/workflows/${id}`;
    case ResourceTypes.WorkflowJob:
      return `/workflows/jobs/${id}`;
    case ResourceTypes.App:
      return `/applications/${id}`;
    default:
      return null;
  }
}

export default function NotificationItemOld(props: NotificationItemPropsOld) {
  const { notification } = props;

  let link = null;
  if (notification.link && notification.link.resourceId) {
    link = (
      <RouterLink
        className="link"
        to={getResourceUrl(notification.link.resourceType, notification.link.resourceId)}
        target="_blank"
        onClick={props.closeNotificationCenter}
      >
        {notification.link.text}
      </RouterLink>
    );
  } else if (notification.link && notification.link.url) {
    link = (
      <a className="link" href={notification.link.url} target="_blank" onClick={props.closeNotificationCenter}>
        {notification.link.text}
      </a>
    );
  }

  return (
    <div
      className={`notification-item-old${notification.status === NotificationStatus.Done ? ' completed' : ''}${
        notification.status === NotificationStatus.Error ? ' error' : ''
      }`}
    >
      {notification.text ? <span className="text">{notification.text}</span> : null}
      {link}
      {!notification.completed ? <FadingCircleLoader /> : null}
      {notification.smallText ? <span className="small-text">{notification.smallText}</span> : null}
      <span className="timestamp">{moment(notification.timestamp).fromNow()}</span>
    </div>
  );
}
